import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Product from "interfaces/Product";
import * as numeral from "numeral";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Product;
}

export default class View extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {
                id: 0,
                name: "",
                sectionVendors: [],
            },
        };
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/products">Items</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>
                            {this.state.data.name}
                        </BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.name}</h3>
                    <div className="box">
                        <div className="full-width">
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">ID</span>
                                    <span className="field-item">
                                        {this.state.data.id}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Code</span>
                                    <span className="field-item">
                                        {this.state.data.mincronId}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Number</span>
                                    <span className="field-item">
                                        {this.state.data.number}
                                    </span>
                                </div>
                                {/*<div className="field-group col-sm-6">*/}
                                {/*    <span className="field-label">Is Kit</span>*/}
                                {/*    <span className="field-item">*/}
                                {/*        {this.state.data.blocked === true ? "Yes" : "No"}*/}
                                {/*    </span>*/}
                                {/*</div>*/}
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-12">
                                    <span className="field-label">Item Name</span>
                                    <span className="field-item">{this.state.data.name}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Category</span>
                                    <span className="field-item">
                                        {this.state.data.sectionName}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">UM</span>
                                    <span className="field-item">
                                        {this.state.data.unitMeasurement}
                                    </span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Vendor Number</span>
                                    <span className="field-item">
                                        {this.state.data.vendorNumber}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Vendor Name</span>
                                    <span className="field-item">{this.state.data.vendor}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Replacement Cost</span>
                                    <span className="field-item ">
                                        {this.state.data.replacementCost &&
                                            numeral(this.state.data.replacementCost).format(
                                                "$0,0.00"
                                            )}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Price 1</span>
                                    <span className="field-item">
                                        {this.state.data.listPrice &&
                                            numeral(this.state.data.listPrice).format("$0,0.00")}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Price 2</span>
                                    <span className="field-item">
                                        {this.state.data.ourListPrice &&
                                            numeral(this.state.data.ourListPrice).format("$0,0.00")}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Price 3</span>
                                    <span className="field-item">
                                        {this.state.data.marketCost &&
                                            numeral(this.state.data.marketCost).format("$0,0.00")}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Price 4</span>
                                    <span className="field-item">
                                        {this.state.data.price4 &&
                                            numeral(this.state.data.price4).format("$0,0.00")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "products/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Product;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${this.state.data.name} - Items - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/products/View.tsx